import {
  getPresupuestoPdfById,
  postPresupuestoGenerateExcel,
} from "api/Presupuesto.service"
import { TipoDocumentoComercialType } from "api/Types/TipoDocumentoComercial"
import { handleDirectDownloadExcel } from "common/context/DownloadFileProvider"
import notification from "common/utils/notification"
import { TFunction } from "i18next"
import fileDownload from "js-file-download"
import { Dispatch, SetStateAction } from "react"

export const handleDownloadPdfPresupuesto = async (
  id: string,
  serie: string,
  t: TFunction
) => {
  try {
    const { data } = await getPresupuestoPdfById(id)

    fileDownload(
      new Blob([data]),
      `${t("types.burget")}${serie ? `_${serie}` : ""}.pdf`
    )

    notification.success({ body: `${t("successMsg.downloadDocument")}` })
  } catch (error) {
    notification.errorServidor({
      body: `${t("errorMsg.downloadDocument")}`,
    })
  }
}

export const handlerExportPresupuestosToExcel = async (
  tipoDocumentoComercial: TipoDocumentoComercialType,
  setIsLoadingExport: Dispatch<SetStateAction<boolean>>,
  t: TFunction
) => {
  try {
    setIsLoadingExport(true)
    const { data } = await postPresupuestoGenerateExcel({
      tipoDocumentoComercial,
    })
    handleDirectDownloadExcel(data, `${t("types.burget")}.xlsx`)
  } catch (err) {
    notification.errorServidor({
      body: `${t("crear.presupuesto.modal.msg.downloadFail")}`,
    })
  } finally {
    setIsLoadingExport(false)
  }
}
